import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select, Avatar, Text, Loader } from '@mantine/core'
import { useUserRelationForm } from './schema/form'
import { getListUserChildables, addUserRelation } from '../../../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'
import { IconCheck } from '@tabler/icons-react'
import { useParams } from 'react-router-dom'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { useDispatch } from 'react-redux'
import { getUserDetail } from '../../../../../store/userDetail'

const defaultRelation = [
  {
    value: '1',
    label: 'Referral'
  },
  {
    value: '2',
    label: 'Sub Agent'
  },
  {
    value: '3',
    label: 'Client'
  }
]

const FormAdjustRelation = ({ onCloseForm }) => {
  const params = useParams()
  const userId = params.id
  const dispatch = useDispatch()

  const [loadingForm, setLoadingForm] = useState(false)
  // users
  const [searchUsers, setSearchUsers] = useState('')
  const [userList, setUserList] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(false)
  const form = useUserRelationForm()

  const submitUserRelation = async (formData) => {
    setLoadingForm(true)
    const payload = {
      ...formData,
      user_id: userId,
    }
    try {
      const response = await addUserRelation(payload)
      if (response.success) {
        setLoadingForm(false)
        notificationSuccess('Add User Relation Success', 'User relation has been added successfully.')
        dispatch(getUserDetail(userId))
        onCloseForm()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      if (errorMessage) {
        form.setFieldError('related_id', 'The selected user is already related.')
      }
      notificationError('Add User Relation Error', errorMessage ? errorMessage : 'Failed to add user relation, please try again.')
      setLoadingForm(false)
    }
  }

  const handleGetUsers = useDebouncedCallback(async () => {
    setLoadingUsers(true)
    const parameter = {
      'filter[name][like]': searchUsers,
      'page[num]': 1,
      'page[limit]': 10,
    }
    try {
      const response = await getListUserChildables(userId, parameter)
      const { data } = response
      const remap = data.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          email: val.attributes.email,
        }
      })
      setUserList(remap)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUsers(false)
    }
  }, 300)

  useEffect(() => {
    handleGetUsers()
    // eslint-disable-next-line
  }, [searchUsers])

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }


  return (
    <Box>
      <Box mb='sm'>
        <Select
          label='Type of Relation'
          key={form.key('group')}
          {...form.getInputProps('group')}
          data={defaultRelation}
          withAsterisk
          size='xs'
          allowDeselect={false}
        />
      </Box>
      <Box mb='sm'>
        <Select
          label='Choose Member'
          key={form.key('related_id')}
          {...form.getInputProps('related_id')}
          data={userList}
          renderOption={renderUserOption}
          size='xs'
          allowDeselect={false}
          searchable
          searchValue={searchUsers}
          onSearchChange={setSearchUsers}
          nothingFoundMessage={!loadingUsers ? userList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
          clearable
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => submitUserRelation(value))}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustRelation